<template>
  <app-layout>
    <div class="h-full flex">
      <div class="flex flex-col w-0 flex-1">
        <main class="flex-1 relative focus:outline-none px-8">
          <bread-nav :pages="pages"></bread-nav>
          <CustomRetroFlow></CustomRetroFlow>
        </main>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "@/Jetstream/Button";
import {message} from "ant-design-vue";
import {
  ref,
  onMounted,
} from "vue";
import JetDialogModal from "@/Jetstream/DialogModal";
import CreateRetroForm from "@/Pages/Retrospective/CreateRetroForm";
import ActionBoard from "@/Pages/Retrospective/ActionBoard/ActionBoard";
import CustomRetroFlow from "@/Pages/Retrospective/CustomRetroFlow";
import PublicBoardList from "@/Pages/Retrospective/PublicBoardList";
import TeamBoardList from "@/Pages/Retrospective/TeamBoardList";
import TeamMemberManager from "@/Pages/Teams/TeamMemberManager";
import TeamSelectionDropdown from "@/Layouts/TeamSelectionDropdown";
import Show from "@/Pages/Teams/Show";
import Feedback from "@/Components/Feedback";
import RetroMetrics from "@/Pages/Retrospective/RetroMetrics";
import {
  ChartPieIcon,
  EyeIcon,
  LightBulbIcon,
  CogIcon,
  MenuIcon
} from "@heroicons/vue/outline";
import BreadNav from "@/Components/BreadNav/BreadNav";

export default {
  props: ['teamId'],
  data() {
    return {
      pages: [],
      currentIndex: 3,
      showSideBar: true,
      testStyle: '  background: -webkit-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -webkit-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -o-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -o-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -moz-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -moz-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), linear-gradient(110deg, #dd0000 66%, #ffc608 66%);'

    };
  },
  mounted() {
    this.pages = [
      {name: 'Retrospective', href: '#', current: false},
      {name: 'Custom Retro Flow', href: '#', current: true},
    ]
  },
  created() {
  },
  setup() {

    const cards = ref([]);
    const createRetroModal = ref(false);

    return {
      createRetroModal,
      cards,
    }
  },

  methods: {
  },
  components: {
    BreadNav,
    ChartPieIcon,
    EyeIcon,
    LightBulbIcon,
    CogIcon,
    MenuIcon,
    RetroMetrics,
    Feedback,
    Show,
    TeamSelectionDropdown,
    TeamMemberManager,
    TeamBoardList,
    PublicBoardList,
    CustomRetroFlow,
    ActionBoard,
    CreateRetroForm,
    JetDialogModal,
    Button,
    AppLayout,
  },
};
</script>
